<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Perquisites"
      text="Create perquisites"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name" 
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="payrollCycleId"
                v-validate="'required'"
                :error-messages="errors.collect('payrollCycleId')"
                :items="payrollCycles"
                data-vv-name="payrollCycleId"     
                data-vv-as="payrollCycleId"
                item-text="name"
                item-value="id"
                value="id"
                label="Payroll Cycle"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <tiptap-vuetify
                v-model="description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card> 
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        description: null,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        payrollCycles: [],
        payrollCycleId: null,
        name: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loading = true
        this.loadPayrollCycles()
        this.loading = false
      },
    },

    methods: { 
      loadPayrollCycles () {
        this.$api.hrisPayrollCycles().list()
          .then(res => {
            this.payrollCycles = res.data
          })
      },
      prepareFormData () {
        return {
          name: this.name,
          description: this.description,
          type: 'perquisite',
          payroll_cycle_id: this.payrollCycleId,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.benefitInKinds().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: 'Perquisite created successfully' })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
